// src/index.js
import "./Utils/logger"; // must stay first: patches console before anything else runs
import "./Utils/authRedirect"; // redirects to /login on any UNAUTHORIZED API response
import "./Utils/singleToast"; // only one toast visible at a time
import './index.css'
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import  store  from "./Redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
